(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
  })();
  (function() {
  if (!__sections__["wave-hero"] && !window.DesignMode) return;
  try {
    

const waveTextPath = document.querySelector("#LT-SHW-text-path");

const ltwh = document.documentElement, 
      ltwb = document.body,
      ltwst = 'scrollTop',
      ltwsh = 'scrollHeight';

document.addEventListener("scroll", e => {
  let percent = (ltwh[ltwst]||ltwb[ltwst]) / ((ltwh[ltwsh]||ltwb[ltwsh]) - ltwh.clientHeight) * 100;
  waveTextPath.setAttribute("startOffset", (-percent * 40))
});


  } catch(e) { console.error(e); }
})();

})();
